export default "__VITE_ASSET__B6cGGz9B__"